import React from "react";
import { FilterOutlined } from "@ant-design/icons";
import { Table, Input, Tooltip, message, Select, Button, Checkbox } from "antd";
import { useEffect, useState } from "react";
import cartIcon from "../../../assets/cartIcon.png";
import { useSelector } from "react-redux";
import rightTickNew from "../../../assets/righTick1.png";
import crossTick from "../../../assets/crossTick.png";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../../utils/axiosInterceptor";

export const OriginalProductList = ({
  setData,
  data,
  setSortOrder,
  accountId,
  allSuppliers,
  setSelectedSuppliers,
  selectedSuppliers,
  getCartData,
  setGenEqActive,
  setOriginalTblData,
}) => {
  const [tempData, setTempData] = useState([]);

  useEffect(() => {
    const mapped = data?.map((item, index) => ({
      ...item,
      id: `${item.product_code}-${index}`,
      purchaseQty: item.purchaseQty,
      // item.purchaseQty && item.purchaseQty >= item.min_qty
      //   ? item.purchaseQty
      //   : item.min_qty,
      stockQty: item.quantity,
      newQuantity: 0,
      do_not_sub: false,
    }));

    setTempData(mapped);
  }, [data]);

  const handleQuantityChange = (value, record) => {
    let newQty = parseInt(value);
    if (newQty > record?.stockQty) {
      message.error(`Only ${record.stockQty} units available`);
      newQty = record.stockQty;
    }

    if (newQty > 1000) {
      message.error("Max order quantity is 1000");
      newQty = 1000;
    }

    const updated = tempData?.map((item) =>
      item.product_code === record.product_code
        ? { ...item, purchaseQty: newQty }
        : item,
    );

    setTempData(updated);
  };
  const updateDoNotSubChange = (checked, record) => {
    const updated = tempData?.map((item) =>
      item.product_code === record.product_code
        ? { ...item, do_not_sub: checked }
        : item,
    );

    setTempData(updated);
  };

  const handleAddToCart = async (product) => {
    if (!product?.purchaseQty || product?.purchaseQty <= 0) {
      message.info("Please enter valid quantity");
      return;
    }
    if (product?.purchaseQty < 1) {
      message.error(`Min order quantity is 1`);
      return;
    }
    const payload = {
      // userId: userAuth?.id,
      acct_id: accountId,
      product_code: product?.product_code,
      quantity: product?.purchaseQty,
      // supplier_name: product?.party_name
      party_id: product?.party_id,
      do_not_sub: product?.do_not_sub,
      brand_type: product?.brand_type,
    };
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/add",
        payload,
        // {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      message.success(response?.data?.message);
      getCartData();
    } catch (error) {
      console.log(error, "Error");
      message.error(error?.response?.data?.message || "Something Went Wrong");
    } finally {
    }
  };

  const columns = [
    {
      title: "Prod ID",
      dataIndex: "product_code",
      key: "product_code",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "NDC ID",
      dataIndex: "item_id",
      key: "item_id",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Description",
      dataIndex: "product_name",
      key: "product_name",
      sorter: false,
    },
    {
      title: "GCN Description",
      dataIndex: "gcn_desc",
      key: "gcn_desc",
      render: (v) => (v ? v : "-"),
      sorter: false,
    },

    {
      title: "Supplier",
      dataIndex: "supplier_display",
      key: "supplier_display",
      sorter: false,
      render: (v, record) => record?.supplier_display || "-",
    },
    //  {
    //   title: "GEN Equiv",
    //   dataIndex: "",
    //   key: "",
    //   render: (_,record) => (
    //     <Button type="primary"
    //     onClick={()=>{
    //       console.log(record,"Recordddd")
    //       setGenEqActive(true)
    //       setOriginalTblData([record])
    //       }}>GE</Button>
    //   ),
    // },
    {
      title: "Unit price",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "right",
      render: (total) =>
        total !== null && total !== undefined
          ? `$ ${Number(total || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-",
      sorter: true,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Avail.",
      key: "avail",
      render: (_, record) => (
        <Tooltip title={record.stockQty > 0 ? "Available" : "Not Available"}>
          {record.stockQty > 0 ? (
            // <CheckCircleOutlined className="text-green-500" />
            <img src={rightTickNew} alt="" className="w-5 h-5" />
          ) : (
            // <CloseCircleOutlined className="text-red-500" />
            <img src={crossTick} alt="" className="w-5 h-5" />
          )}
        </Tooltip>
      ),
    },
    {
      title: "Do Not Sub.",
      dataIndex: "do_not_sub",
      key: "do_not_sub",
      render: (doNotSub, record) => (
        <Checkbox
          checked={!!doNotSub}
          disabled={record?.supplier_display !== "McKesson"}
          onChange={(e) => updateDoNotSubChange(e.target.checked, record)}
          className="rounded-sm"
        />
        // <span>-</span>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      align: "right",
      render: (q) => {
        const quan = Number(q);
        return quan > 100 ? <span>&gt;100</span> : <span>{quan}</span>;
      },
    },
    {
      title: "Purchase qty",
      key: "purchaseQty",
      render: (_, record) => (
        <div className="flex items-center space-x-2">
          <Input
            type="number"
            min={1}
            max={1000}
            value={record.purchaseQty}
            onChange={(e) => handleQuantityChange(e.target.value, record)}
            className="w-20 text-right"
          />
          <Tooltip title="Add to cart">
            <img
              src={cartIcon}
              alt=""
              onClick={() => handleAddToCart(record)}
              className="h-7 w-7 cursor-pointer p-1 rounded-md hover:bg-gray-200"
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={tempData}
      rowKey="id"
      scroll={{ x: "max-content" }}
      className="custom-table user-tbl"
      pagination={false}
    />
  );
};

export const EquivalentProductList = ({
  setData,
  data,
  current,
  pageSize,
  total,
  onPageChange,
  loading,
  sortOrder,
  setSortOrder,
  setCurrentPage,
  accountId,
  allSuppliers,
  setSelectedSuppliers,
  selectedSuppliers,
  getCatalogueDetails,
  getCartData,
  setGenEqActive,
  setOriginalTblData,
}) => {
  const [tempData, setTempData] = useState([]);
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const navigate = useNavigate();

  useEffect(() => {
    const mapped = data?.map((item, index) => ({
      ...item,
      id: `${item.product_code}-${index}`,
      purchaseQty: item.purchaseQty,
      // item.purchaseQty && item.purchaseQty >= item.min_qty
      //   ? item.purchaseQty
      //   : item.min_qty,
      stockQty: item.quantity,
      newQuantity: 0,
      do_not_sub: false,
    }));

    setTempData(mapped);
  }, [data]);

  const handleQuantityChange = (value, record) => {
    let newQty = parseInt(value);
    if (newQty > record?.stockQty) {
      message.error(`Only ${record.stockQty} units available`);
      newQty = record.stockQty;
    }

    if (newQty > 1000) {
      message.error("Max order quantity is 1000");
      newQty = 1000;
    }

    const updated = tempData?.map((item) =>
      item.product_code === record.product_code
        ? { ...item, purchaseQty: newQty }
        : item,
    );

    setTempData(updated);
  };
  const updateDoNotSubChange = (checked, record) => {
    const updated = tempData?.map((item) =>
      item.product_code === record.product_code
        ? { ...item, do_not_sub: checked }
        : item,
    );

    setTempData(updated);
  };

  const handleAddToCart = async (product) => {
    if (!product?.purchaseQty || product?.purchaseQty <= 0) {
      message.info("Please enter valid quantity");
      return;
    }
    if (product?.purchaseQty < 1) {
      message.error(`Min order quantity is 1`);
      return;
    }
    const payload = {
      // userId: userAuth?.id,
      acct_id: accountId,
      product_code: product?.product_code,
      quantity: product?.purchaseQty,
      // supplier_name: product?.party_name
      party_id: product?.party_id,
      do_not_sub: product?.do_not_sub,
      brand_type: product?.brand_type,
    };
    try {
      const response = await axiosInstance.post(
        "api/marketplace/cart/add",
        payload,
        // {
        //     headers : {
        //       "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //     }
        //   },
      );
      message.success(response?.data?.message);
      getCartData();
    } catch (error) {
      console.log(error, "Error");
      message.error(error?.response?.data?.message || "Something Went Wrong");
    } finally {
    }
  };

  const columns = [
    {
      title: "Prod ID",
      dataIndex: "product_code",
      key: "product_code",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "NDC ID",
      dataIndex: "item_id",
      key: "item_id",
      render: (val) =>
        val ? (
          <div className="flex items-center gap-2">
            <span>{val}</span>
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: false,
    },
    {
      title: "Description",
      dataIndex: "product_name",
      key: "product_name",
      sorter: false,
    },
    {
      title: "GCN Description",
      dataIndex: "gcn_desc",
      key: "gcn_desc",
      render: (v) => (v ? v : "-"),
      sorter: false,
    },

    {
      title: "Supplier",
      dataIndex: "supplier_display",
      key: "supplier_display",
      sorter: false,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div className="p-3 w-[250px]">
          <Select
            mode="multiple"
            allowClear
            placeholder="Select Supplier"
            className="w-full"
            value={selectedSuppliers}
            onChange={(values) => {
              setSelectedSuppliers(values);
              setCurrentPage(1);
            }}
            options={allSuppliers?.map((supplier) => ({
              label: supplier?.supplierName,
              value: supplier?.supplierName,
            }))}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <FilterOutlined
          style={{
            color: filtered ? "#001997" : undefined,
          }}
        />
      ),
      render: (v, record) => record?.supplier_display || "-",
    },
    // {
    //   title: "GCR Impact",
    //   dataIndex: "gcr_impact",
    //   key: "gcr_impact",
    //   render: (impact) => (
    //     <Tooltip
    //       title={
    //         impact > 0
    //           ? "Positive Impact"
    //           : impact === 0
    //             ? "Average Impact"
    //             : "Negative Impact"
    //       }
    //     >
    //       {impact > 0 ? (
    //         <ArrowUpOutlined className="text-green-500" />
    //       ) : impact === 0 ? (
    //         <MenuOutlined className="text-gray-500" />
    //       ) : (
    //         <ArrowDownOutlined className="text-red-500" />
    //       )}
    //     </Tooltip>
    //   ),
    // },
    //  {
    //   title: "GEN Equiv",
    //   dataIndex: "",
    //   key: "",
    //   render: (_,record) => (
    //     <Button type="primary"
    //     onClick={()=>{
    //       console.log(record,"Recordddd")
    //       setGenEqActive(true)
    //       setOriginalTblData([record])
    //       }}>GE</Button>
    //   ),
    // },
    {
      title: "Unit price",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "right",
      render: (total) =>
        total !== null && total !== undefined
          ? `$ ${Number(total || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-",
      sorter: true,
      sortDirections: ["descend", "ascend", "descend"],
    },
    //  {
    //   title: "Price",
    //   dataIndex: "price",
    //   key: "price",
    //   render: (price) => `-`,
    //   // sorter: (a, b) => a.unit_price - b.unit_price,
    // },
    {
      title: "Avail.",
      key: "avail",
      render: (_, record) => (
        <Tooltip title={record.stockQty > 0 ? "Available" : "Not Available"}>
          {record.stockQty > 0 ? (
            // <CheckCircleOutlined className="text-green-500" />
            <img src={rightTickNew} alt="" className="w-5 h-5" />
          ) : (
            // <CloseCircleOutlined className="text-red-500" />
            <img src={crossTick} alt="" className="w-5 h-5" />
          )}
        </Tooltip>
      ),
    },
    {
      title: "Do Not Sub.",
      dataIndex: "do_not_sub",
      key: "do_not_sub",
      render: (doNotSub, record) => (
        <Checkbox
          checked={!!doNotSub}
          disabled={record?.supplier_display !== "McKesson"}
          onChange={(e) => updateDoNotSubChange(e.target.checked, record)}
          className="rounded-sm"
        />
        // <span>-</span>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      align: "right",
      render: (q) => {
        const quan = Number(q);
        return quan > 100 ? <span>&gt;100</span> : <span>{quan}</span>;
      },
    },
    {
      title: "Purchase qty",
      key: "purchaseQty",
      render: (_, record) => (
        <div className="flex items-center space-x-2">
          <Input
            type="number"
            min={1}
            max={1000}
            value={record.purchaseQty}
            onChange={(e) => handleQuantityChange(e.target.value, record)}
            className="w-20 text-right"
          />
          <Tooltip title="Add to cart">
            <img
              src={cartIcon}
              alt=""
              onClick={() => handleAddToCart(record)}
              className="h-7 w-7 cursor-pointer p-1 rounded-md hover:bg-gray-200"
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={tempData}
      rowKey="id"
      scroll={{ x: "max-content" }}
      loading={loading}
      className="custom-table user-tbl"
      pagination={{
        current,
        total,
        pageSize,
        showSizeChanger: true,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      }}
      onChange={(pagination, filters, sorter, extra) => {
        if (extra.action === "sort" && sorter?.field === "unit_price") {
          setCurrentPage(1);
          setSortOrder(sorter?.order === "descend" ? "desc" : "asc");
        } else if (extra.action === "paginate") {
          onPageChange(pagination.current, pagination.pageSize);
        }
      }}
      rowClassName={(record) => (record.hsc ? "bg-[#ECFFD9]" : "")}
    />
  );
};
